"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RequiredSpan = exports.InputSubVStack = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _VerticalStack = _interopRequireDefault(require("../../VerticalStack/index.js"));
const InputSubVStack = exports.InputSubVStack = (0, _styledComponents.default)(_VerticalStack.default)`
	justify-content: center;
	cursor: text;
`;
const RequiredSpan = exports.RequiredSpan = _styledComponents.default.span`
	${props => {
  const {
    requiredStarColor
  } = props;
  return `	
		color: ${requiredStarColor};
		padding-left: 3px;`;
}}
`;